// Customer-facing names and policy links. Reviewed is the product; Norix Legal
// LLC, the law firm behind the reviews, is named only where the law needs it
// (the charge authorization, set on the server).
export const PRODUCT_NAME = "Reviewed";
export const SUPPORT_EMAIL = "support@reviewed.work";

// These routes display the exact server-owned factual test-beta notices.
export const POLICY_URLS = {
  privacy: "/privacy",
  betaAgreement: "/beta",
  terms: "/terms",
  privilege: "/privilege",
};
